import React, {useEffect, useState} from 'react'
import {Dropdown, Image} from 'react-bootstrap'
import InputMask from 'react-input-mask'
import PhoneInput from 'react-phone-number-input'
import getCountries from 'src/feature/become-merchant/services/getCountries'
import './style.css'

const MaskedInput = React.forwardRef<any, any>(({value, onChange, ...rest}, ref) => {
  const toggleEl = document.querySelector('.dropdown-toggle')
  const countryCode = toggleEl?.querySelector('span')?.textContent?.replace('+', '')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\D/g, '')
    onChange(rawValue)
  }

  return (
    <InputMask
      mask={countryCode && countryCode === '971' ? '99 999 9999' : '999 999 9999'}
      value={value}
      className='w-100 PhoneInputInput'
      maskChar={null}
      onChange={handleChange}
      // {...rest}
    >
      {(inputProps) => <input {...inputProps} ref={ref} placeholder='Enter phone number' />}
    </InputMask>
  )
})

export default function PhoneNumberInput({values, setFieldValue, setTouched, colName = 'phone'}) {
  const [countries, setCountries] = useState([]) as any
  const [selectedCountry, setSelectedCountry] = useState({
    id: 'f109e594-b301-ec11-a85d-000d3a229408',
    name: 'United Arab Emirates',
    englishName: 'United Arab Emirates',
    code: '971',
    code2: 'ARE',
    exCode: 'AE',
    flag: '/UploadedFiles/flags/are.png',
    mobilePhoneNumberFormat: '(XX) XXX-XXXX',
    order: 1,
  }) as any

  useEffect(() => {
    getCountries().then((res) => {
      setCountries(res)
    })
  }, [])

  function CustomCountrySelectWithFlags({value, onChange}) {
    if (!selectedCountry) {
      return <div>Loading</div>
    }

    const imgDomain = process.env.REACT_APP_IMG_DOMAIN?.replace('/UploadedFiles/', '')

    return (
      <div className=''>
        <Dropdown className='w-100'>
          <Dropdown.Toggle
            className='w-100 d-flex align-items-center justify-content-between form-select'
            as='div'
          >
            <img
              src={`${imgDomain}${selectedCountry?.flag}`}
              height={'auto'}
              width={20}
              className='me-2'
              alt={selectedCountry?.name}
            />
            <span>+{selectedCountry?.code}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className='w-100' style={{maxHeight: '300px', overflowY: 'auto'}}>
            {countries
              ?.filter((country) => country?.code === 971)
              ?.map((c: any) => (
                <Dropdown.Item
                  key={c.exCode}
                  className='d-flex align-items-center'
                  active={selectedCountry === c.exCode}
                  onSelect={() => {
                    onChange(c.exCode)
                    setSelectedCountry(c)
                    setFieldValue('countryCode', c.exCode)
                  }}
                  onClick={() => {
                    setFieldValue(colName, '')
                    setSelectedCountry(c)
                    setFieldValue('countryCode', c.exCode)
                    setTouched({[colName]: false})
                  }}
                >
                  <Image src={`${imgDomain}${c.flag}`} width={20} className='me-2' />
                  {`${c.exCode} (+${c.code})`}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }

  const allowedCountryCodes = countries.map((c: any) => c.exCode)

  return (
    <>
      <PhoneInput
        placeholder='Enter phone number'
        className='w-100'
        value={values?.[colName] || ''}
        defaultCountry='AE'
        international={false}
        countries={allowedCountryCodes}
        countrySelectComponent={CustomCountrySelectWithFlags}
        onBlur={() => {
          setTouched({[colName]: true})
        }}
        onFocus={() => {
          setTouched({[colName]: false})
        }}
        onChange={(value) => {
          setFieldValue(colName, value)
        }}
        inputComponent={MaskedInput}
      />
    </>
  )
}
